/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./BarcodeCard.css'); }
var noCreditPaymentIconSrc = require("../../img/metro/digitalcard/icon-no-credit-small.svg");
var SVGImage_1 = require("../SVGImage");
var moduleClassNameFactory_1 = require("../util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-barcodeCard");
var requiredString = PropTypes.string.isRequired;
exports.barcodeCardTypesArray = [
    "blue",
    "gold",
    "red",
    "green",
    "tr-bl",
    "tr-pc",
    "nl-bl",
    "nl-si",
    "nl-vp",
    "nl-go",
    "nl-pc",
    "ro-bl",
    "ro-si",
    "ro-go",
    "ro-vp",
    "ro-pc",
    "de-bl",
    "de-si",
    "de-go",
    "de-pc",
    "de-eu"
];
exports.BarcodeCard = function BarcodeCard(props) {
    var children = props.children, noCreditPayment = props.noCreditPayment, onNoCreditPaymentClick = props.onNoCreditPaymentClick, cardholderName = props.cardholderName, companyName = props.companyName, cardNumberLabel = props.cardNumberLabel, cardNumber = props.cardNumber, cardType = props.cardType, cardTypeLabel = props.cardTypeLabel;
    var noCreditPaymentIcon = React.createElement(SVGImage_1.SVGImage, { src: noCreditPaymentIconSrc });
    return (React.createElement("div", { className: moduleClassName() },
        React.createElement("div", { className: moduleClassName("code") }, children),
        React.createElement("div", { className: moduleClassName("section") },
            React.createElement("p", null,
                cardholderName,
                React.createElement("br", null),
                !!companyName ? React.createElement("strong", null, companyName) : React.createElement("br", null))),
        React.createElement("div", { className: classnames(moduleClassName("section"), !!noCreditPayment && moduleClassName("hasImage")) },
            React.createElement("p", null,
                React.createElement("small", null, cardNumberLabel),
                React.createElement("br", null),
                cardNumber),
            !!noCreditPayment &&
                (onNoCreditPaymentClick ? (React.createElement("a", { href: "#", className: moduleClassName("noCreditPaymentLink"), onClick: function (e) {
                        e.preventDefault();
                        return onNoCreditPaymentClick(e);
                    } }, noCreditPaymentIcon)) : (noCreditPaymentIcon))),
        React.createElement("div", { className: classnames(moduleClassName("secure"), moduleClassName(cardType)) },
            React.createElement("strong", null, cardTypeLabel),
            React.createElement("span", null),
            React.createElement("span", null),
            React.createElement("span", null),
            React.createElement("span", null),
            React.createElement("span", null),
            React.createElement("span", null))));
};
exports.BarcodeCard.propTypes = {
    noCreditPayment: PropTypes.bool,
    onNoCreditPaymentClick: PropTypes.func,
    cardholderName: requiredString,
    companyName: PropTypes.string,
    cardNumberLabel: requiredString,
    cardNumber: requiredString,
    cardType: PropTypes.oneOf(exports.barcodeCardTypesArray)
        .isRequired,
    cardTypeLabel: requiredString
};
exports.BarcodeCardPagination = function BarcodeCardPagination(_a) {
    var children = _a.children, index = _a.index, className = _a.className, props = tslib_1.__rest(_a, ["children", "index", "className"]);
    return (React.createElement("nav", { className: classnames(moduleClassName("pagination"), className) }, React.Children.map(children, function (child, childIndex) {
        return React.cloneElement(child, {
            active: index === childIndex
        });
    })));
};
exports.BarcodeCardPagination.propTypes = {
    index: PropTypes.number.isRequired,
    className: PropTypes.string
};
exports.BarcodeCardPaginationButton = function BarcodeCardPaginationButton(_a) {
    var active = _a.active, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["active", "children", "className"]);
    return (React.createElement("button", tslib_1.__assign({ className: classnames(moduleClassName("paginationButton"), active && moduleClassName("paginationButton-isActive"), className) }, props),
        React.createElement("span", { className: moduleClassName("paginationIndicator") }, children)));
};
exports.BarcodeCardPaginationButton.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string
};